import { render } from "./Setting.vue?vue&type=template&id=1216c376"
const script = {}
script.render = render

export default script